import { apiFetchAllRewardTask } from '@/api/imee'

export const mixin = {
  data() {
    return {
      percentageValue: 0,
      rewardNumber: 0,
      showRewardDia: false,
      total: {},
      // 新手任务完成之后的提醒
      newTaskfinishFlag: false,
      showNewTaskFinishDia: false,
      // 气泡提醒
      bubbleShow: true,
    }
  },
  methods: {
    // 替换所有的 - 为 .
    replaceTime(val) {
      return val.replace(/-/g, '.')
    },

    // 处理title 切割不带括号的
    handleTitle1(tit) {
      if (tit && tit.indexOf('(') > 0) {
        return tit.slice(0, tit.indexOf('('))
      }
      return tit
    },
    // 处理title 切割带括号的
    handleTitle2(tit) {
      if (tit && tit.indexOf('(') > 0) {
        return tit.slice(tit.indexOf('('))
      }
      return ''
    },

    // 进度条值取最大值 三个中 当前值（proc))
    // 计算三段节点的进度值
    handlePercentage(conditions) {
      if (conditions && conditions.length > 1) {
        let val = 0
        if (conditions[0].proc < conditions[0].goal) {
          val = conditions[0].proc / conditions[0].goal
          return (val / 3) * 100
        }
        if (conditions[1].proc < conditions[1].goal) {
          val = conditions[0].proc / conditions[0].goal + (conditions[1].proc - conditions[0].proc) / (conditions[1].goal - conditions[0].goal)
          return (val / 3) * 100
        }
        if (conditions[2].proc <= conditions[2].goal) {
          val =
            conditions[0].proc / conditions[0].goal +
            conditions[1].proc / conditions[1].goal +
            (conditions[2].proc - conditions[1].proc) / (conditions[2].goal - conditions[1].goal)
          return (val / 3) * 100
        }
      }
    },
    // 计算节点进度值
    handleComputeProgress(conditions) {
      try {
        if (Array.isArray(conditions)) {
          const endObject = conditions[conditions.length - 1]
          let progress = (endObject.proc / endObject.goal) * 100
          if (progress > 100) progress = 100
          return progress
        }
      } catch (error) {
        return 0
      }
    },
    // 计算每个值所占的比例
    handleComputeNodeValue(list) {
      if (list) {
        const endObject = list[list.length - 1]
        const ratio = endObject.goal / 100
        return ratio
      }
    },

    // 有三段的时候 取最大的proc
    threeMaxProc(conditions) {
      if (conditions && conditions.length) {
        let maxObj = conditions[0]
        conditions.forEach((item) => {
          if (item.proc > maxObj.proc) {
            maxObj = item
          }
        })

        if (maxObj.proc != 0 && !isNaN(maxObj.proc) && maxObj.procDisplay) {
          return maxObj.procDisplay
        }
      }
      return ''
    },

    // online -- call 计算时间
    // 目标值为一小时
    onlineProc(time) {
      // 传值为秒
      if (Number(time) < 3600 && Number(time) > 0) {
        return Math.floor(time / 60) + 'm'
      }
      if (time >= 3600) {
        return 1 + 'hrs'
      }
      if (time == 0) {
        return ''
      }
    },

    // 目标值为10分钟 600
    callProc(time) {
      // 传值为秒
      if (Number(time) < 600 && Number(time) > 0) {
        return Math.floor(time / 60) + 'm'
      }
      if (time >= 600) {
        return 1 + 'hrs'
      }
      if (time == 0) {
        return ''
      }
    },

    // 计算秒
    handleSecondsHours(val) {
      if (val) {
        return Math.floor(val / 3600) // 小时数
      }
    },
    handleSecondsMinutes(val) {
      if (val) {
        return Math.floor((val % 3600) / 60) // 分钟数
      }
    },
    // Online Call进度值
    handlePercentageOnlineCall(val1, val2) {
      if (val1 < val2) {
        return (val1 / val2) * 100
      } else if (val1 >= val2) {
        return 100
      }
    },
    // 判断状态 当有三个点的进度条
    // 当状态有一个为1 就可以领取了 //任务状态 0:进行中 1:完成待提交 2:已提交
    handleStatus(arr) {
      if (arr && arr.length > 0) {
        const list = []
        arr.forEach((item) => {
          list.push(item.state)
        })

        if (this.countOccurrences(list, 1) >= 1) {
          return 1
        }
        if (this.countOccurrences(list, 2) == list.length) {
          return 2
        }
        return 0
      }
    },
    countOccurrences(array, value) {
      return array.filter((item) => item === value).length
    },
    stateSuccessNum(arr) {
      if (arr) {
        const list = arr.filter((item) => {
          return item.state == 1
        })
        if (list.length > 0) {
          return list.length
        }
      }
    },
    // 计算总金额
    taskTotal(taskArr) {
      let a1 = 0
      let a2 = 0
      let b1 = 0
      let b2 = 0
      const obj = {
        total: 0,
        reward: 0,
      }
      taskArr.forEach((item) => {
        if (item.conditions && item.conditions.length > 1) {
          item.conditions.forEach((option) => {
            option.rewardList.forEach((reward) => {
              a1 += reward.rewardPropNum
              if (option.state == 2) {
                a2 += reward.rewardPropNum
              }
            })
          })
        } else {
          b1 += item.conditions[0].rewardList[0].rewardPropNum
          if (item.conditions[0].state == 2) {
            b2 += item.conditions[0].rewardList[0].rewardPropNum
          }
        }
        obj.total = a1 + b1
        obj.reward = a2 + b2
      })
      return obj
    },
    // 新领取任务 一键领取可领取节点
    handleRward(item, val) {
      if (item.taskId) {
        apiFetchAllRewardTask(item.taskId).then((res) => {
          if (res) {
            this.rewardNumber = res.rewardPropNum || 0
            this.showRewardDia = true
            if (val && val == 'new' && res.ifFinishedNewerTask) {
              this.newTaskfinishFlag = res.ifFinishedNewerTask
            }

            this.$parent.fetchHostessTaskPage()
          }
        })
      }
    },
    // 箭头是跳转
    handleArrow(item) {
      this.appActionPro(item.gotoUrl)
    },
    handleRewardDiaConfirm() {
      this.closeShowRewardDia()
    },
    // 关闭弹窗
    closeShowRewardDia() {
      this.showRewardDia = false
      if (this.newTaskfinishFlag) {
        this.showNewTaskFinishDia = true
      } else {
        this.$parent.fetchHostessTaskPage()
      }
    },
    // 总数
    getTotalNum(task) {
      if (task) {
        this.total = this.taskTotal(task)
      }
    },
    bubbleTipsControl() {
      this.bubbleShow = false
    },
  },
  created() {
    window.addEventListener('click', this.bubbleTipsControl)
  },
  beforeDestory() {
    window.removeEventListener('click', this.bubbleTipsControl)
  },
}
